import AK from './states/AK.geojson?url';
import AL from './states/AL.geojson?url';
import AR from './states/AR.geojson?url';
import AZ from './states/AZ.geojson?url';
import CA from './states/CA.geojson?url';
import CO from './states/CO.geojson?url';
import CT from './states/CT.geojson?url';
import DE from './states/DE.geojson?url';
import FL from './states/FL.geojson?url';
import GA from './states/GA.geojson?url';
import HI from './states/HI.geojson?url';
import IA from './states/IA.geojson?url';
import ID from './states/ID.geojson?url';
import IL from './states/IL.geojson?url';
import IN from './states/IN.geojson?url';
import KS from './states/KS.geojson?url';
import KY from './states/KY.geojson?url';
import LA from './states/LA.geojson?url';
import MA from './states/MA.geojson?url';
import MD from './states/MD.geojson?url';
import ME from './states/ME.geojson?url';
import MI from './states/MI.geojson?url';
import MN from './states/MN.geojson?url';
import MO from './states/MO.geojson?url';
import MS from './states/MS.geojson?url';
import MT from './states/MT.geojson?url';
import NC from './states/NC.geojson?url';
import ND from './states/ND.geojson?url';
import NE from './states/NE.geojson?url';
import NH from './states/NH.geojson?url';
import NJ from './states/NJ.geojson?url';
import NM from './states/NM.geojson?url';
import NV from './states/NV.geojson?url';
import NY from './states/NY.geojson?url';
import OH from './states/OH.geojson?url';
import OK from './states/OK.geojson?url';
import OR from './states/OR.geojson?url';
import PA from './states/PA.geojson?url';
import RI from './states/RI.geojson?url';
import SC from './states/SC.geojson?url';
import SD from './states/SD.geojson?url';
import TN from './states/TN.geojson?url';
import TX from './states/TX.geojson?url';
import UT from './states/UT.geojson?url';
import VA from './states/VA.geojson?url';
import VT from './states/VT.geojson?url';
import WA from './states/WA.geojson?url';
import WI from './states/WI.geojson?url';
import WV from './states/WV.geojson?url';
import WY from './states/WY.geojson?url';

export default { AK, AL, AR, AZ, CA, CO, CT, DE, FL, GA, HI, IA, ID, IL, IN, KS, KY, LA, MA, MD, ME, MI, MN, MO, MS, MT, NC, ND, NE, NH, NJ, NM, NV, NY, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VA, VT, WA, WI, WV, WY };
